import { QueryClient } from "@tanstack/react-query";
import { ASSIGNMENTS_QUERIES } from "~/shared/api/assignments/assignments.queries";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export async function homeViewLoader(queryClient: QueryClient) {
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  queryClient.prefetchQuery(USERS_QUERIES.surveys(user.id.toString(), {}));
  queryClient.prefetchQuery(ASSIGNMENTS_QUERIES.user.all());

  return null;
}
